import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown
} from '../../common/form/FieldHelper';

class ContactDropdown extends Component {
  render() {
    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      excluded_entities
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="contact"
          searchParams={{
            excluded_entities
          }}
          type="contact"
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          onPostChange={onPostChange}
          valueField="id"
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown
    },
    dispatch
  );
}

export default connect(
  null,
  mapDispatchToProps
)(ContactDropdown);
